export default "__VITE_ASSET__rkwttP1r__"